import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { PerformanceService } from '../service/performance.service';

export const performanceInterceptor: HttpInterceptorFn = (req, next) => {
  const performanceService = inject(PerformanceService);
  
  if (req.url.includes('/api/performance/track.php')) {
    return next(req);
  }

  const startTime = performance.now();
  
  return next(req).pipe(
    finalize(() => {
      const duration = performance.now() - startTime;
      performanceService.trackDuration(`HTTP:${req.url}`, duration);
    })
  );
};
